<div class="error">
  <!-- downloadable error template -->
  <div *ngIf="isSceneJSError; else notSceneJSError">
    <h1 class="text-24 text-bold">
      The BioDigital Human encountered an error.
    </h1>
    <h2 class="text-16 mt-4 mb-8">
      Error: <span class="text-semibold">{{ sceneJSErrorTeaser }}</span>
    </h2>
    
    <div class="text-16 mb-4">
      To receive assistance with this error, please follow these steps:
    </div>

    <ol class="text-16">
      <li class="mv-4">
        <button
          app-button
          buttonType="outline"
          buttonTheme="light"
          (click)="handleDownloadClick()"
        >
          Download
        </button>
        the error report.
      </li>
      <li class="mv-4">
          <button
            app-button
            buttonType="outline"
            buttonTheme="light"
            (click)="handleActionClick(supportURL)"
          >
            Share the report
          </button>
          with the customer support team.
      </li>
    </ol>

    <div class="mt-8">
      <button
        app-button
        buttonType="outline"
        buttonTheme="light"
        buttonSize="xsmall"
        *ngIf="!viewSceneJSErrorDetails"
        (click)="handleSeeDetailsClick()"
      >
        See Details
      </button>
      <div>
        <textarea
          *ngIf="viewSceneJSErrorDetails"
          class="error__details mt-2"
          [value]="sceneJSErrorReport"
        >
        </textarea>
      </div>
    </div>
  </div>

  <ng-template #notSceneJSError>
    <!-- title -->
    <div class="text-24 text-bold">
      {{ title }}
    </div>

    <!-- actions-->
    <div class="flex items-start mt-10">
      <ng-container>
        <button
          app-button
          buttonType="outline"
          buttonTheme="light"
          (click)="handleActionClick(supportURL)"
        >
          Contact Support
        </button>
      </ng-container>
    </div>

    <!-- description -->
    <div
      class="error__description text-16 mt-8"
      [innerHTML]="description"
    ></div>
  </ng-template>
</div>
